import type { SVGProps } from 'react';

const SvgAssetTypeSubclip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M3.29 17.29c-.18.19-.29.45-.29.71s.11.52.29.71c.19.18.45.29.71.29s.52-.11.71-.29c.18-.19.29-.45.29-.71s-.11-.52-.29-.71c-.37-.37-1.05-.37-1.42 0M20 17h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1M18 4H6C4.35 4 3 5.35 3 7v7c0 .55.45 1 1 1s1-.45 1-1V7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v7c0 .55.45 1 1 1s1-.45 1-1V7c0-1.65-1.35-3-3-3"
    />
    <path
      fill="currentcolor"
      d="m14.54 10.21-3.6-2.08c-.61-.35-1.38.09-1.38.79v4.16c0 .71.76 1.15 1.38.79l3.6-2.08a.92.92 0 0 0 0-1.59zM13 16c-.55 0-1 .45-1 1H8c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1h4c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1"
    />
  </svg>
);
export default SvgAssetTypeSubclip;
